<template>
    <div class="budgetary-question budgetary-assertive-question">
            
        <fieldset class="form-group" :class="{ completed: hasBeenAnswered }">
            <p>
                <strong>
                    <slot></slot>
                </strong>
            </p>
            
            <div class="form-check">
                <label class="form-check-label">
                    <input type="radio" :name="name" :value=1 v-model="afirmative" class="form-check-input" @click="$emit('input', true)">
                    {{ afirmativeLabel }}
                </label>
            </div>

            <div class="form-check">
                <label class="form-check-label">
                    <input type="radio" :name="name" :value=0 v-model="afirmative" class="form-check-input" @click="$emit('input', false)">
                    {{ negativeLabel }}
                </label>
            </div>
        </fieldset>

        <slot v-if="afirmative" name="afirmative"></slot>
        <slot v-if="negative" name="negative"></slot>
        <slot v-if="hasBeenAnswered" name="answered"></slot>

    </div>
</template>

<script>
    export default {
        props: {
            name: { type: String, required: false },
            afirmativeLabel: { type: String, required: false, default: "Sí" },
            negativeLabel: { type: String, required: false, default: "No" },
        },

        computed: {
            negative: function () {
                return ! this.afirmative && this.afirmative != null;
            },
            hasBeenAnswered: function () {
                return this.afirmative != null;
            },
        },

        data: function () {
            return {
                afirmative: null,
            }
        },

        destroyed: function () {
            this.$emit( 'input', null );
        },
    }
</script>

<style lang="scss">
    @import "./../../../sass/variables";

    .budgetary-assertive-question {
        > fieldset.completed {
            opacity: 0.35;
            transition: opacity .5s ease-in-out;

            &:hover {
                opacity: 1;
            }
        }

        > .form-group label {
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/AssertiveQuestion.vue